import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '@/views/Home.vue'
import Login from '@/views/Login.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/home',
    name: 'Home',
    component: Home,
    meta: { requiresAuth: true }
  },
  {
    path: '*',
    redirect: '/login'
  }
]

const router = new VueRouter({
  mode: 'hash',
  routes
})

// Глобальный защитник маршрутов
router.beforeEach((to, from, next) => {
  const token = sessionStorage.getItem('authToken')
  
  // Если маршрут требует авторизации и токена нет
  if (to.meta.requiresAuth && !token) {
    next('/login')
  } 
  // Если токен есть и пользователь на странице логина - перенаправляем на home
  else if (to.path === '/login' && token) {
    next('/home')
  } 
  // Во всех остальных случаях разрешаем переход
  else {
    next()
  }
})

export default router